import React, { FC } from 'react'
import { Image } from '@/atoms/Image'

interface Props {
  imageUrl: string
}

export const BackgroundBlurImage: FC<Props> = ({ imageUrl }) => {
  return (
    <>
      <div className="absolute h-full w-full overflow-hidden">
        <Image
          loading="lazy"
          className="h-full w-full scale-150 blur-xl"
          alt=""
          src={imageUrl}
          quality={1}
          width={100}
          height={100}
        />
      </div>
      <div className="absolute inset-0 block h-full bg-black/80" />
    </>
  )
}
